import { baseUrlService } from 'ui-toolkit/rest/BaseUrlService';
import { IStandardDocumentData } from '../../types/order/documents/shared/interfaces';
import { IDocumentCategory } from 'types/order/documents/IDocumentCategoryType';

export const positiveDocumentDownloadUrl = (
  orderId: string,
  document: IStandardDocumentData,
  documentCategories: IDocumentCategory[]
) => {
  const docOption = documentCategories.find((option) => option.name === document.category);
  const repeatable = docOption && docOption.isRepeatable ? 'unversioned' : 'versioned';
  return `${baseUrlService.ApiLocation}/documents/v4/${orderId}/${
    document.category
  }/${repeatable}/download/${doubleEncodeUri(document.fileName)}`;
};

const doubleEncodeUri = (fileName: string) => encodeURIComponent(encodeURIComponent(fileName));
